/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAddresses200,
  GetApiV1PersonIdAddresses401,
  GetApiV1PersonIdAddresses404,
  GetApiV1PersonIdAddresses500,
  GetApiV1PersonIdAddressesPathParams,
  GetApiV1PersonIdAddressesQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdAddresses.ts";
import { personAddressDetailViewModelSchema } from "../personAddressDetailViewModelSchema.ts";

export const getApiV1PersonIdAddressesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdAddressesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAddresses200Schema = z.array(
  z.lazy(() => personAddressDetailViewModelSchema),
) as unknown as ToZod<GetApiV1PersonIdAddresses200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAddresses401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddresses401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAddresses404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddresses404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAddresses500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAddresses500>;

export const getApiV1PersonIdAddressesQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdAddresses200Schema,
) as unknown as ToZod<GetApiV1PersonIdAddressesQueryResponse>;
